import { useDispatch, useSelector, useStore } from "react-redux";
import {
  LanguageData,
  registerNewKeys,
  requestArrayOfKeys,
  selectCurrentLanguage,
  selectTrainingLocalizationState,
  setLanguageIncludeInPublish,
  updateLocalizedString,
} from "../../app/slices/TrainingLocalizationSlice";
import { RootState } from "../../app/Store";

export const useTrainingLocalization = () => {
  const dispatch = useDispatch();
  const store = useStore<RootState>();
  const locState = useSelector(selectTrainingLocalizationState);
  const currLang = useSelector(selectCurrentLanguage);

  function allocateKeys(amount: number) {
    const currentState = selectTrainingLocalizationState(store.getState());
    const newKeys = requestArrayOfKeys(currentState, amount);
    dispatch(registerNewKeys(newKeys));
    return newKeys;
  }

  function getNewKey() {
    return allocateKeys(1)[0];
  }

  function getValue(key: string) {
    const localizedEntry = locState.localizedEntries[key];
    if (!localizedEntry) return "";

    const currentLanguageEntry = localizedEntry[currLang.shortcode];
    if (!currentLanguageEntry) return "";

    return currentLanguageEntry.value;
  }

  function changeValue(key: string, newValue: string, shortcode?: string) {
    dispatch(updateLocalizedString({ key, newValue, shortcode }));
  }

  function GetArrayOfKeys(amount: number) {
    return allocateKeys(amount);
  }

  return { getValue, changeValue, getNewKey, GetArrayOfKeys } as const;
};

export const useToggleLanguageIncludeInPublish = () => {
  const dispatch = useDispatch();

  const toggleIncludeInPublish = (languageData: LanguageData) => {
    const newValue = !(languageData.includeInPublish ?? true);

    dispatch(
      setLanguageIncludeInPublish({
        shortcode: languageData.shortcode,
        includeInPublish: newValue,
      })
    );
  };

  return { toggleIncludeInPublish } as const;
};

export const useSetLanguageIncludeInPublish = () => {
  const dispatch = useDispatch();

  const setIncludeInPublish = (
    languageData: LanguageData,
    includeInPublish: boolean
  ) => {
    dispatch(
      setLanguageIncludeInPublish({
        shortcode: languageData.shortcode,
        includeInPublish,
      })
    );
  };

  return { setIncludeInPublish } as const;
};
